import { PaywallCheckoutContextProvider } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { CheckoutPage } from "./CheckoutPage";
import type { CheckoutProps } from "./CheckoutProps";
import { CheckoutV2 } from "./CheckoutV2";
import { useIsPaywallsCheckoutCustomizationPhase1Enabled } from "./hooks/useIsPaywallsCheckoutCustomizationPhase1Enabled";

export const CheckoutWithPMC = (props: CheckoutProps) => {
  const { currentCommunityProcessorPaymentMethodConfigurationId } = props;
  const isPaywallsCheckoutCustomizationPhase1Enabled =
    useIsPaywallsCheckoutCustomizationPhase1Enabled(props);

  if (!currentCommunityProcessorPaymentMethodConfigurationId) {
    return null;
  }

  return (
    <PaywallCheckoutContextProvider
      {...props}
      currentCommunityProcessorPaymentMethodConfigurationId={
        currentCommunityProcessorPaymentMethodConfigurationId
      }
      isPaywallsCheckoutCustomizationPhase1Enabled={
        isPaywallsCheckoutCustomizationPhase1Enabled
      }
      // To be removed once `currentCommunityProcessorPaymentMethodConfigurationId` becomes the default
      paymentMethodsSupported={[]}
      disabledPaymentMethods={[]}
      setDisabledPaymentMethods={() => {}}
      paymentElementKey=""
    >
      {isPaywallsCheckoutCustomizationPhase1Enabled ? (
        <CheckoutV2 />
      ) : (
        <CheckoutPage />
      )}
    </PaywallCheckoutContextProvider>
  );
};
